import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@Sage/hoi-poi-ui';
import classNames from 'classnames';
import './styles.scss';

const SetupStatusIcon = memo(({ isCompleted = false, className = '' }) => {
    return (
        <div className={classNames('setup-status-icon', className)}>
            {isCompleted ? (
                <div className="setup-status-icon__check-wrapper">
                    <Icon name="check" color="white" />
                </div>
            ) : (
                <div className="setup-status-icon__empty-circle" />
            )}
        </div>
    );
});

SetupStatusIcon.displayName = 'SetupStatusIcon';

SetupStatusIcon.propTypes = {
    isCompleted: PropTypes.bool,
    className: PropTypes.string,
};

export default SetupStatusIcon;
